module.exports = __webpack_public_path__ + "img/Drivers_Climate_Status.5d7a14d3.jpg";